import * as React from "react";
import Exposure from "./ExposureModel";
import ModelContainer from "../../../components/model/ModelContainer";
import PageTitle from "../../../components/model/PageTitle";
import ModelTitle from "../../../components/model/ModelTitle";
import ModelInfo from "../../../components/model/ModelInfo";
import {GAEventModels} from "../../../utils/SendGAEvent";
import ModelDescription from "../../../components/model/ModelDescription";
import DisclaimerTitle from "../../../components/model/Disclaimer/DisclaimerTitle";
import DisclaimerDescription from "../../../components/model/Disclaimer/DisclaimerDescription";
import DisclaimerText from "../../../components/model/Disclaimer/DisclaimerText";
import TabPanel from "../../../components/model/TabPanel";

const TenQ = () => {
  return <ModelContainer>
      <PageTitle/>
      <div>
        <ModelTitle>Exposure Analysis</ModelTitle>
        <ModelInfo model={GAEventModels.EXPOSURE_ANALYZER}/>
        <TabPanel
            modelName={GAEventModels.EXPOSURE_ANALYZER}
            modelDescription={<ModelDescription>Outputs a list of assets which will give exposure to specific news events.</ModelDescription>}
            content={<Exposure/>}
        />
        <hr/>
        <DisclaimerTitle>Disclaimer</DisclaimerTitle>
        <DisclaimerDescription>
            *Beta version only include exposure output for 20 selected news events
            <br/>
            {DisclaimerText}
        </DisclaimerDescription>
        <hr/>
      </div>
    </ModelContainer>;
};

export default TenQ;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/Exposure/index.tsx